import {
  PropertiesManagementThunk,
  PROPERTIES_MANAGEMENT_SET_LOCATION_TREE,
  PropertiesManagementSetLocationTreeActionType,
} from './propertyManagementActionTypes';
import { AUTH_NAMESPACE } from '../Auth/authReducer';
import { PropertiesManagementLocation } from './propertyManagementTypes';
import { startLoaderThunk, stopLoaderThunk } from '../modal/modalActions';
import { PropertiesManagementDataTransformFetchLocation } from './propertyManagementHelper';
import PropertiesManagementApi from '../../API/property-management/PropertiesManagement.api';

export function propertiesManagementSetPropertiesAction(
  location: PropertiesManagementLocation
): PropertiesManagementSetLocationTreeActionType {
  return {
    type: PROPERTIES_MANAGEMENT_SET_LOCATION_TREE,
    location,
  };
}

export function propertyManagementFetchLocationTreeThunk(): PropertiesManagementThunk<
  Promise<void>
> {
  return async (dispatch, getState) => {
    dispatch(startLoaderThunk()).finally();
    const authState = getState()[AUTH_NAMESPACE];
    if (!authState.profile.locationId) {
      return;
    }

    PropertiesManagementApi.getLocationTree(authState.profile.locationId)
      .then((response) => {
        dispatch(
          propertiesManagementSetPropertiesAction(
            PropertiesManagementDataTransformFetchLocation(response.data)
          )
        );
      })
      .finally(() => {
        dispatch(stopLoaderThunk());
      });
  };
}
